
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.075 12.267"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_29690","data-name":"Group 29690","transform":"translate(.6 .6)"}},[_c('g',{attrs:{"id":"b"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"d","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1.2"}},[_c('path',{attrs:{"id":"e","d":"M6.3 11.527A5.637 5.637 0 01.473 6.1V6a5.417 5.417 0 011.14-3.31A5.56 5.56 0 014.626.643 5.026 5.026 0 015.86.464a5.658 5.658 0 013.379 1.089A4.856 4.856 0 0111.2 4.345","transform":"translate(-.473 -.464)"}}),_c('ellipse',{attrs:{"id":"f","cx":"2.298","cy":"2.961","rx":"2.298","ry":"2.961","transform":"translate(2.732 2.57)"}}),_c('path',{attrs:{"id":"g","d":"M8.6 3.323v4.944a1.266 1.266 0 001.3 1.098 1.879 1.879 0 001.557-1.2","transform":"translate(-1.15 -.702)"}}),_c('path',{attrs:{"id":"h","d":"M12.131 4.7a4.572 4.572 0 01.1 1.83 3.925 3.925 0 01-.519 1.745","transform":"translate(-1.409 -.816)"}})])])])])])
          )
        }
      }
    